<template>
  <div class="login-form-wrapper">
    <div class="arrow-container-3">
      <a @click="goToBack">
        <img src="@/assets/timeslot-images/left-arrow.svg"
      /></a>
    </div>
    <div class="div-block-20">
      <div class="div-block login">
        <div class="text-block">Set Password 🔐</div>
        <div
          class="text-block-3"
          style="font-family: 'Galano grotesque-Medium', sans-serif;"
        >
          Enter your desired password to your account
        </div>
        <!--        title-->
      </div>
    </div>
    <div class="div-block">
      <FormulateForm>
        <!--        <span @click="togglePassword" style="cursor: pointer;">-->
        <img
          v-if="type === 'password'"
          @click="togglePassword"
          style="cursor: pointer;"
          src="@/assets/timeslot-images/visual.png"
          class="password-eye"
        />
        <img
          @click="togglePassword"
          style="cursor: pointer;"
          v-else
          src="@/assets/timeslot-images/eye.png"
          class="password-eye"
        />
        <!--        </span>-->
        <FormulateInput
          :type="type"
          name="password"
          placeholder="Password"
          validation="bail|required"
          validation-name="Password"
          v-model="password"
          error-behavior="value"
        />
        <!--        validation="bail|required|min:4,length|max:6,length|matches:/^(?=(.*?[0-9]){4})/"-->
        <!--        max:8|min:6-->
        <!--                validation="required|matches:/[0-9][A-Z]/|max:8|min:6"-->
        <!--        <span @click="toggleConfirmPassword" style="cursor: pointer;">-->

        <!--        ^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$-->
        <!--        ^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[#?!@$%^&*-]).{6,8}$-->
        <img
          v-if="typeConfirm === 'password'"
          src="@/assets/timeslot-images/visual.png"
          class="password-eye"
          @click="toggleConfirmPassword"
          style="cursor: pointer;"
        />
        <img
          v-else
          src="@/assets/timeslot-images/eye.png"
          class="password-eye"
          @click="toggleConfirmPassword"
          style="cursor: pointer;"
        />
        <!--        </span>-->
        <FormulateInput
          :type="typeConfirm"
          name="password_confirm"
          validation="bail|required|confirm"
          placeholder="Confirm password"
          validation-name="Password Confirmation"
          v-model="passwordConfirm"
        />
        <FormulateInput type="submit" label="Continue" @click="savePassword" />
      </FormulateForm>
    </div>
    <div class="text-block-2">© {{ currentYear() }} Timeslate</div>
  </div>
</template>

<script>
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";

export default {
  name: "TimeslotPasswordForm",
  data() {
    return {
      password: "",
      passwordConfirm: "",
      type: "password",
      typeConfirm: "password",
      image: "visual"
    };
  },
  methods: {
    goToBack() {
      RouterUtils.changeRouteUrlTo("/enrollment");
    },
    savePassword() {
      if (this.password === this.passwordConfirm) {
        StoreUtils.commit("auth/setPassword", this.password);
        StoreUtils.commit("auth/setPasswordConfirm", this.passwordConfirm);
        RouterUtils.changeRouteUrlTo("/verify-email");
      }
    },
    togglePassword() {
      if (this.type === "password") {
        this.type = "text";
        this.image = "eye";
      } else {
        this.type = "password";
        this.image = "visual";
      }
    },
    toggleConfirmPassword() {
      if (this.typeConfirm === "password") {
        this.typeConfirm = "text";
        this.image = "eye";
      } else {
        this.typeConfirm = "password";
        this.image = "visual";
      }
    },
    currentYear() {
      let current_date = new Date();
      let current_year = current_date.getFullYear();
      return current_year;
    }
  }
};
</script>

<style scoped>
.password-eye {
  position: relative;
  top: 38px;
  left: 43%;
  width: 20px;
  height: 20px;
  opacity: 0.7;
}
</style>
